import classNames from "classnames";

import styles from "./calendar.module.css";

/** type: "primary" | "secondary" | "shift" | "info" | "cancel" | "low" | "mean" | "high" | "range"  */
export const CalendarDay = ({ date, type = "primary", onClick }) => {
    return (
        <>
            <div onClick={onClick} className={classNames(styles.calendar_day, styles[type])}>
                {date.getDate()}
            </div>
        </>
    )
}
